import Paper from "@material-ui/core/Paper";
import {Grid, Typography} from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";
import {useBoxWithImageStyles} from "./BoxWithImageStyles";
import Box from "@material-ui/core/Box";
import {Skeleton} from "@material-ui/lab";
import {getRandomNumber} from "../../utils/utils";

const BoxWithImage = (props) => {
    const classes = useBoxWithImageStyles(props);

    return (
        <Box className={classes.root}>
            <Paper className={classes.paper}>
                <Grid container spacing={2}>
                    {props.image ?
                        <Grid item>
                            <img className={classes.img} alt="complex" src={props.image}/>
                        </Grid>
                        : null}
                    <Grid item xs={12} sm container>
                        <Grid item xs container direction="column" spacing={2}>
                            <Grid item xs container alignItems='center'>
                                <Box mt='5px' width='100%'>
                                    <Typography className={classes.title} variant="overline">
                                        {props.loading ? <Skeleton animation='wave'
                                                                   width={`${getRandomNumber(30, 60)}%`}/> : props.title}
                                    </Typography>
                                    {props.loading ? <Skeleton animation='wave'
                                                               width={`${getRandomNumber(50, 80)}%`}/> :
                                        props.image ?
                                            <Typography className={classes.breakWord}
                                                        variant="h5">
                                                {props.content}
                                            </Typography>
                                            : props.content}

                                    {props.isSim ? <Typography variant="caption">
                                        {props.loading ?
                                            <Skeleton animation='wave' width={`${getRandomNumber(50, 80)}%`}/> :
                                            `${props.graySimQuantity} attivabili - ${props.whiteSimQuantity} sostitutive`}
                                    </Typography> : null}
                                </Box>
                            </Grid>

                        </Grid>
                        {props.secondTitle ?
                        <Grid item xs container direction="column" spacing={2}>
                            <Grid item xs container alignItems='center'>
                                <Box mt='5px' width='100%'>
                                    <Typography className={classes.title} variant="overline">
                                        {props.loading ? <Skeleton animation='wave'
                                                                   width={`${getRandomNumber(30, 60)}%`}/> : props.secondTitle}
                                    </Typography>

                                    <Typography className={classes.breakWord}
                                                variant="h5">
                                        {props.loading ? <Skeleton animation='wave'
                                                                   width={`${getRandomNumber(50, 80)}%`}/> : props.secondContent}
                                    </Typography>

                                    {props.isSim ? <Typography variant="caption">
                                        {props.loading ?
                                            <Skeleton animation='wave' width={`${getRandomNumber(50, 80)}%`}/> :
                                            `${props.graySimQuantity} attivabili - ${props.whiteSimQuantity} sostitutive`}
                                    </Typography> : null}
                                </Box>
                            </Grid>

                        </Grid>: null}
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    );
}

BoxWithImage.propTypes = {
    title: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
    isSim: PropTypes.bool,
    graySimQuantity: PropTypes.string,
    whiteSimQuantity: PropTypes.string,
    loading: PropTypes.bool
}

BoxWithImage.defaultProps = {
    loading: false
}

export default BoxWithImage
